import { apiClient } from "./client";
import type { Paginated, PageQuery } from "@/types/common";
import type {
  AutoRuleSetting,
  BroadcastInput,
  NotificationItem,
  NotificationQueueStats,
  NotificationTemplate,
} from "@/types/notification";

export interface NotificationsQuery extends PageQuery {
  status?: string;
  channel?: string;
  search?: string;
}

export async function fetchNotifications(query: NotificationsQuery): Promise<Paginated<NotificationItem>> {
  const { data } = await apiClient.get<Paginated<NotificationItem>>("/notifications", { params: query });
  return data;
}

export async function fetchNotificationQueueStats(): Promise<NotificationQueueStats> {
  const { data } = await apiClient.get<NotificationQueueStats>("/notifications/stats");
  return data;
}

export async function fetchTemplates(): Promise<NotificationTemplate[]> {
  const { data } = await apiClient.get<NotificationTemplate[]>("/notifications/templates");
  return data;
}

export async function updateTemplate(code: string, payload: Partial<NotificationTemplate>): Promise<NotificationTemplate> {
  const { data } = await apiClient.patch<NotificationTemplate>(`/notifications/templates/${code}`, payload);
  return data;
}

export async function fetchAutoRules(): Promise<AutoRuleSetting[]> {
  const { data } = await apiClient.get<AutoRuleSetting[]>("/notifications/auto-rules");
  return data;
}

export async function updateAutoRule(templateCode: string, enabled: boolean): Promise<AutoRuleSetting> {
  const { data } = await apiClient.patch<AutoRuleSetting>(`/notifications/auto-rules/${templateCode}`, { enabled });
  return data;
}

export async function runAutoRules(): Promise<{ queued: number }> {
  const { data } = await apiClient.post<{ queued: number }>("/notifications/run-auto-rules");
  return data;
}

export async function sendQueue(): Promise<{ sent: number; failed: number }> {
  const { data } = await apiClient.post<{ sent: number; failed: number }>("/notifications/send-queue");
  return data;
}

export async function sendBroadcast(payload: BroadcastInput): Promise<{ queued: number }> {
  const { data } = await apiClient.post<{ queued: number }>("/notifications", payload);
  return data;
}
